/* Keep binary artwork intact: the theme JSON serializer converts Files to strings. */
(() => {
 const file=document.getElementById('business-artwork');
 const form=file?.form;if(!form)return;
 let pending=false;
 form.addEventListener('submit',async event=>{

  event.preventDefault();event.stopImmediatePropagation();
  if(pending||!form.reportValidity())return;
  const status=document.querySelector('[data-cp-message]');
  const say=text=>{if(status)status.textContent=text;};
  if(form.querySelector('input[name="Colour"]')&&!form.querySelector('input[name="Colour"]:checked')){say('Please choose a cooler color.');return;}
  const notes=form.querySelector('#textarea-1');
  if(!notes?.value.trim()){say('Please add your branding or print instructions.');notes?.focus();return;}
  if(file.files[0]?.size>20*1024*1024){say('Please choose an artwork file smaller than 20 MB.');return;}
  pending=true;const button=form.querySelector('[type="submit"]');if(button)button.disabled=true;
  say('Uploading your artwork and adding your coolers…');
  const data=new FormData(form);
  // Use meaningful order labels while preserving native app metadata.
  data.delete('properties[First & Last Name(s) / Special Instructions]');
  data.delete('properties[datetime-1]');
  if(!file.files.length)data.delete('properties[Artwork]');
  data.set('properties[Branding instructions]',notes.value);
  const date=form.querySelector('#datetime-1')?.value;
  if(date)data.set('properties[Requested delivery date]',date);
  try{
   const response=await fetch(form.action.replace(/\/add(?:\.js)?$/, '/add.js'),{method:'POST',body:data,headers:{Accept:'application/json'}});
   const result=await response.json();
   if(!response.ok)throw new Error(result.description||'Your artwork could not be added. Please try again.');
   window.location.assign(form.action.replace(/\/add(?:\.js)?$/, ''));
  }catch(error){say(error.message||'Please check your cart before trying again.');pending=false;if(button)button.disabled=false;}
 },true);
})();
